import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown-button__label" }




export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownButton',
  props: ['label', 'isOpen'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["q-btn q-btn q-btn-sm q-bg-white q-dropdown-toggle q-mb-1 q-rounded-3 q-shadow-sm q-fw-semibold", {'dropdown__open': __props.isOpen}]),
    type: "button",
    "aria-expanded": "false"
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1),
    _cache[0] || (_cache[0] = _createElementVNode("span", {
      class: "dropdown-button__icon",
      "aria-hidden": "true"
    }, null, -1))
  ], 2))
}
}

})